import React from 'react';

const AddNew = ({ onClick }) => {
    return (
        <button  type="button"  onClick={onClick} className="absolute bottom-2 right-2 px-4 py-2 bg-blue-600 text-white rounded shadow-lg" > + Add New </button>
    );
};

export default AddNew;